<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    width="24"
  ><path d="M4 15v-2h16v2Zm0-4V9h16v2Z" /></svg>
</template>

<script>
export default {
  name: 'DragIcon',
};
</script>
<style scoped lang="scss">
svg {
  fill: main.$npGray;
}
</style>
